import { HttpClient } from '@angular/common/http';
import { Observable, Subject, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { AttachmentAttachmentRead, AttachmentService } from '../openapi';
import { environment } from '../../environments/environment';
import Map from 'ol/Map';

export interface MapSearchResponseItem {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  boundingbox: Array<string>;
  lat: string;
  lon: string;
  display_name: string;
  class: string;
  type: string;
  importance: number;
  icon: string;
}

@Injectable()
export class OpenStreetApi {
  constructor(
    private http: HttpClient,
    private attachmentService: AttachmentService
  ) {
  }

  public search(address: string): Observable<MapSearchResponseItem[]> {
    return this.http.get<MapSearchResponseItem[]>(`https://nominatim.openstreetmap.org/search.php?format=json&adressdetails=1&q=${address}, Długołęka`);
  }

  public createMapImage(map: Map): Observable<AttachmentAttachmentRead> {
    const result = new Subject<AttachmentAttachmentRead>();
    const mapCanvas = document.createElement('canvas');
    const size = map?.getSize() || [];
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];
    const mapContext = mapCanvas.getContext('2d');

    Array.prototype.forEach.call(
      map?.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
      function(canvas) {
        if (canvas.width > 0) {
          const opacity =
            canvas.parentNode.style.opacity || canvas.style.opacity;
          mapContext!.globalAlpha = opacity === '' ? 1 : Number(opacity);
          let matrix;
          const transform = canvas.style.transform;
          if (transform) {
            // Get the transform parameters from the style's transform matrix
            matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
          } else {
            matrix = [
              parseFloat(canvas.style.width) / canvas.width,
              0,
              0,
              parseFloat(canvas.style.height) / canvas.height,
              0,
              0
            ];
          }
          // Apply the transform to the export map context
          CanvasRenderingContext2D.prototype.setTransform.apply(
            mapContext,
            matrix
          );
          const backgroundColor = canvas.parentNode.style.backgroundColor;
          if (backgroundColor) {
            mapContext!.fillStyle = backgroundColor;
            mapContext?.fillRect(0, 0, canvas.width, canvas.height);
          }
          mapContext?.drawImage(canvas, 0, 0);
        }
      }
    );
    mapCanvas.toBlob((b) => {
      if (b) {
        const file = new File([b], 'map_image.png');
        this.uploadAttachment({
          file,
          tag: 'map_image'
        }).toPromise().then(v => {
          result.next(v as AttachmentAttachmentRead);
        });
      }
    });
    return result.asObservable();
  }

  private uploadAttachment(payload: { file: File; tag: string }): Observable<AttachmentAttachmentRead> {
    const formData = new FormData();
    formData.append('file', payload.file);
    return this.http.post<AttachmentAttachmentRead>(environment.apiBasePath + '/attachments', formData)
      .pipe(
        switchMap(attachment =>
          this.attachmentService.apiAttachmentsPatchItemAttachmentItem({
            id: attachment?.id || '',
            attachment: {
              tag: payload.tag
            }
          })
        )
      );
  }
}
